import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Check, X, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BukkuLogs() {
  const [logs, setLogs] = useState([]);
  const load = () => api.get("/bukku/sync-logs").then(r => setLogs(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div>
      <header className="mb-6 flex items-end justify-between">
        <div>
          <div className="caption">Accounting</div>
          <h1 className="font-heading text-3xl font-extrabold mt-1">Bukku Sync Logs</h1>
          <p className="text-slate-500 mt-1 text-sm">Every push attempt from CargoLedger to Bukku. Use failed responses to identify the correct API path.</p>
        </div>
        <Button variant="outline" onClick={load}><RefreshCw className="w-4 h-4 mr-1.5" />Refresh</Button>
      </header>
      <div className="space-y-3">
        {logs.map(l => (
          <div key={l.id} className="rounded-lg border border-slate-200 bg-white p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {l.ok ? <Check className="w-4 h-4 text-emerald-600" /> : <X className="w-4 h-4 text-rose-600" />}
                <span className="font-mono text-sm">{l.kind}</span>
                <span className="text-xs text-slate-500">{l.at?.slice(0,19).replace("T"," ")} · {l.by}</span>
              </div>
              {l.ref && <span className="text-xs rm-badge">ref {l.ref}</span>}
            </div>
            {l.error && <div className="mt-2 text-xs text-rose-600">{l.error}</div>}
            {l.attempts?.length > 0 && (
              <div className="mt-2 rounded border border-slate-100 overflow-hidden">
                <table className="excel-table w-full text-xs">
                  <thead><tr><th>Status</th><th>URL</th><th>Response</th></tr></thead>
                  <tbody>
                    {l.attempts.map((a, i) => (
                      <tr key={i}>
                        <td className={`font-mono ${a.status && String(a.status).startsWith("2") ? "text-emerald-600" : "text-slate-500"}`}>{a.status}</td>
                        <td className="font-mono text-xs">{a.url}</td>
                        <td className="font-mono text-xs text-slate-500 max-w-md truncate">{a.text}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
        {logs.length === 0 && <div className="text-center py-16 text-slate-400 border border-dashed border-slate-200 rounded-lg">No sync attempts yet.</div>}
      </div>
    </div>
  );
}
